/** @jsxImportSource @emotion/react */
import { TextNova } from "@/components/TextNova";
import { IconApp } from "@/modules/IconApp";
import { Button } from "antd";
import { ReactEventHandler } from "react";
import { channelCartCss } from "./style";

type ChannelCartProps = {
  icon: string;
  onClick: ReactEventHandler;
  texts: {
    title: string;
    subtitle: string;
    description: string;
    button: string;
  };
};

export const ChannelCart = (props: ChannelCartProps) => {
  const { icon, onClick, texts } = props;
  return (
    <section css={channelCartCss}>
      <div>
        <IconApp name={icon} fontSize={45} color="primary" />
      </div>
      <div>
        <TextNova variant="title3">{texts.title}</TextNova>
        <TextNova variant="subtitle3">{texts.subtitle}</TextNova>
        <TextNova variant="text">{texts.description}</TextNova>
        <Button type="primary" onClick={onClick}>
          {texts.button}
        </Button>
      </div>
    </section>
  );
};
